import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  ContentCopy as CopyIcon,
  Settings as SettingsIcon,
  Link as LinkIcon,
  BugReport as BreakpointIcon,
} from '@mui/icons-material';

function NodeContextMenu({
  open,
  anchorEl,
  onClose,
  node,
  onEdit,
  onDelete,
  onCopy,
  onConnect,
  onToggleBreakpoint,
  breakpoints = [],
}) {
  if (!node) return null;
  const nodeId = node.id || node.data?.id;
  const hasBreakpoint = nodeId && breakpoints.includes(nodeId);
  const isStartOrEnd = node?.type === 'start' || node?.type === 'end';

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          minWidth: 180,
          boxShadow: 3,
        },
      }}
    >
      <MenuItem onClick={() => { onEdit(node); onClose(); }}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Configure Node</ListItemText>
      </MenuItem>

      <MenuItem onClick={() => { onConnect(node); onClose(); }}>
        <ListItemIcon>
          <LinkIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Start Connection</ListItemText>
      </MenuItem>

      <MenuItem onClick={() => { onCopy(node); onClose(); }}>
        <ListItemIcon>
          <CopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Copy Node</ListItemText>
      </MenuItem>

      {onToggleBreakpoint && !isStartOrEnd && (
        <MenuItem onClick={() => { onToggleBreakpoint(nodeId); onClose(); }}>
          <ListItemIcon>
            <BreakpointIcon fontSize="small" color={hasBreakpoint ? 'error' : 'inherit'} />
          </ListItemIcon>
          <ListItemText>{hasBreakpoint ? 'Remove Breakpoint' : 'Add Breakpoint'}</ListItemText>
        </MenuItem>
      )}

      <Divider />

      <MenuItem
        onClick={() => { onDelete(node); onClose(); }}
        sx={{ color: 'error.main' }}
      >
        <ListItemIcon>
          <DeleteIcon fontSize="small" color="error" />
        </ListItemIcon>
        <ListItemText>Delete Node</ListItemText>
      </MenuItem>
    </Menu>
  );
}

export default NodeContextMenu;
